import React from "react";
import { Badge, BadgeColor, depascalize } from "sprint-common-web";

import { ContentVersionSource } from "../types/ContentVersionSource";

export const ContentVersionSourceBadge = (props: { value?: ContentVersionSource; testId?: string }): JSX.Element => {
    return (
        <Badge
            color={props.value ? sourceBadgeColor[props.value] : BadgeColor.Gray}
            text={props.value ? depascalize(ContentVersionSource[props.value]) : "-"}
            testId={props.testId}
        />
    );
};

const sourceBadgeColor: Record<ContentVersionSource, number> = {
    [ContentVersionSource.Buzz]: BadgeColor.LightBlue,
    [ContentVersionSource.Shreq]: BadgeColor.LightGreen,
    [ContentVersionSource.Sprint]: BadgeColor.Gray,
    [ContentVersionSource.Trailer]: BadgeColor.Blue
};
